import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";

const HideActionsButton = () => {
  const dispatch = useDispatch();
  const isHideActions = useSelector((state) => state.leadActivity.isHideActions);
  const setHideActions = () => {
    return dispatch(actionCreators.setHideActions(!isHideActions));
  };
  return (
    <button className="hide-actions-button" onClick={() => setHideActions(!isHideActions)}>
      {isHideActions ? "Show Actions" : "Hide Actions"}
    </button>
  );
};

export default HideActionsButton;
